import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import * as commonActions from './../../actions/commonActions';
import * as dashboardActions from './../../actions/dashboardActions';
import * as changePasswordActions  from './../../actions/changePasswordActions';
import * as tradeBookActions from './../../actions/tradeBookActions';
import styles from './../MenuBar/MenuBar.less';
import Modal from 'react-modal';
import {Button, ButtonToolbar, DropdownButton, MenuItem} from 'react-bootstrap';
import i18next from 'i18next';
import $ from 'jquery';
import { applyStyleapplyToHover, getSelectedDate,setDirection } from './../../utils/utils';
let unlockFlag = 0;
const elementsData = [
  {"classNames":"settingDropdown", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"dropdown-menu", "elementType":"normal", "applyTo":"all", "tagNames":"li"},
  {"classNames":"profileButton", "elementType":"normal", "applyTo":"all", "tagNames":"button"}
]
const directionData = [
  {"classNames":"button_Content", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"savebutton", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"btnText", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"row_Content", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
];
@connect(
  state => ({
    userDetail: state.auth.userDetail,
    DFA: state.auth.DFA,
    ACD: state.auth.ACD,
    allCssColor: state.dashboardRoot.commonReducer.allCssColor,
    selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
    selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
    langList:state.dashboardRoot.dashboardReducer.langList,
    selectedTheme:state.auth.selectedTheme,
    selectedLang:state.dashboardRoot.commonReducer.selectedLang,
    language:state.dashboardRoot.commonReducer.language
  }),
    {...commonActions,...dashboardActions,...changePasswordActions,...tradeBookActions})

export default class Setting extends Component {

  static propTypes = {
    saveSettings:PropTypes.func,
    userDetail:PropTypes.object,
    blankMsg:PropTypes.func,
    unlockModal:PropTypes.number,
    DFA:PropTypes.object,
    allCssColor:PropTypes.object,
    langList:PropTypes.object,
    getAllOrdersTrd:PropTypes.func,
    setShowProfileFlag:PropTypes.func,
  }
  state = {
    account_Name:'',
    account_Code:'',
    enableIntTrad:'',
    lastTrdQty:'',
    enableToolTip:'',
    lng:'',
    selectedLng: '',
    accountList:Array.from(this.props.ACD.values()),
    selectedCssColor:'',
    selectedCssColorId:'',
    isMarginWithOrders:''
  };
  componentWillMount(){
     this.setState({selectedCssColorId:this.props.selectedCssColor});
     this.props.allCssColor.map((item) => {
       if(item.theme_code===this.props.selectedCssColor){
         this.setState({selectedCssColor:item.theme_name});
       }
     });
  }
  componentDidMount(){
    //console.log(this.props.userDetail.themeType)
      const thisComponent = ReactDOM.findDOMNode(this);
      //const allCssStyleRules = this.props.selectedCssColorTheme;
      //applyStyle(thisComponent, allCssStyleRules, elementsData);
      const hoverElementsClassNames = [
        {"elmToHover":thisComponent.getElementsByClassName("profileButton")[0], "classNames":"profileButton"}
      ];
      ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
      setDirection(thisComponent,directionData,this.props.selectedLang);
      this.setState({enableIntTrad:this.props.userDetail.isTrdInstant});
      this.setState({lastTrdQty:this.props.userDetail.storetradeqty});
      this.setState({enableToolTip:this.props.userDetail.showStock});
      this.setState({isMarginWithOrders:this.props.userDetail.isMarginWithOrders});
      this.setState({account_Name:this.props.DFA.D});
      this.setState({account_Code:this.props.DFA.C});
      this.setState({fontsize:this.props.userDetail.fontSize});
      this.setState({lng: this.props.userDetail.LN});
      if(this.props.userDetail.LN == 'EN'){
        this.setState({selectedLng: 'English'});
      }
      else if (this.props.userDetail.LN == 'DU') {
        this.setState({selectedLng: 'Dutch'});
      }
      else if (this.props.userDetail.LN == 'AR') {
        this.setState({selectedLng: 'Arabic'});
      }
      else if (this.props.userDetail.LN == 'FR'){
        this.setState({selectedLng: 'French'});
      }
      else if (this.props.userDetail.LN == 'SP') {
        this.setState({selectedLng: 'Spanish'});
      }
        else if (this.props.userDetail.LN == 'RU') {
        this.setState({selectedLng: 'Russian'});
      }
        else if (this.props.userDetail.LN == 'CN') {
        this.setState({selectedLng: 'Chinese'});
      }
      else {
        this.setState({selectedLng: 'Turkish'});
      }
      this.setState({selectedCssColorId:this.props.selectedCssColor});
      this.props.allCssColor.map((item) => {
        if(item.theme_code===this.props.selectedCssColor){
          this.setState({selectedCssColor:item.theme_name});
        }
      });
  }

  selectLang = (key, event) => {
    try{
      this.setState({lng:key});
      this.setState({selectedLng: event});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'selectLang', component:"Setting"});
    }
  }

  changeThemeHanlder = (val) => {
    try{
      this.setState({selectedCssColor:val.theme_name});
      this.setState({selectedCssColorId:val.theme_code});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changeThemeHanlder', component:"Setting"});
    }
  }

  changeDefaultAcc = (account_Code,acc_name) => {
    try{
      this.setState({account_Name: acc_name});
      this.setState({account_Code: account_Code});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changeDefaultAcc', component:"Setting"});
    }
  }

  enableTradeChange = (event) => {
    try{
      this.setState({ enableIntTrad: event.target.value});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'enableTradeChange', component:"Setting"});
    }
  }

  lastTrdQtyChange = (event) =>{
    try{
      this.setState({ lastTrdQty: event.target.value});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'lastTrdQtyChange', component:"Setting"});
    }
  }

  withOrdChange = (event) =>{
    try{
      this.setState({ isMarginWithOrders: event.target.value});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'withOrdChange', component:"Setting"});
    }
  }

  tooltipChange = (event) => {
    try{
      this.setState({ enableToolTip: event.target.value});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'tooltipChange', component:"Setting"});
    }
  }

  selectfont =(event)=>{
    try{
      this.setState({fontsize: event.target.value});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'selectfont', component:"Setting"});
    }
  }

  saveSetting = (event) => {
    try{
      i18next.changeLanguage(this.state.lng, (err, t) => {
          if (err) return console.log('something went wrong loading', err);
          this.props.changeLanguage(this.state.lng);
      });
      i18next.loadLanguages(this.state.lng, (err, t) => {});
      i18next.on('loaded', function(loaded) {});
      i18next.on('languageChanged', function(lng) {});
      this.props.setTheme(this.state.selectedCssColorId);
      this.props.blankMsg();
      const DefaultACCod=this.state.account_Code
      const isTrdInstant=this.state.enableIntTrad;
      const storetradeqty=this.state.lastTrdQty;
      const showStockPrc= this.state.enableToolTip;
      const isMarginWithOrders=this.state.isMarginWithOrders;
      this.props.saveSettings(DefaultACCod,isTrdInstant,storetradeqty,showStockPrc,isMarginWithOrders,this.state.fontsize,this.state.lng,this.state.selectedCssColorId);
      this.props.getAllOrdersTrd(DefaultACCod);
      this.props.setShowProfileFlag(false);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'saveSetting', component:"Setting"});
    }
  }

  componentWillReceiveProps(nextprops,nextState){

    // if(this.props.selectedCssColorTheme !== nextprops.selectedCssColorTheme){
    //   const thisComponent = ReactDOM.findDOMNode(this);
    //   const allCssStyleRules = nextprops.selectedCssColorTheme;
    //   applyStyle(thisComponent, allCssStyleRules, elementsData);
    //   const hoverElementsClassNames = [
    //     {"elmToHover":thisComponent.getElementsByClassName("profileButton")[0], "classNames":"profileButton"}
    //   ];
    //   //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    // }
    if (this.props.selectedLang !== nextprops.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(ReactDOM.findDOMNode(this),directionData,nextprops.selectedLang);
    }
  }

  render() {
      const {account_Name,classname} = this.state;
      return (
        <div className={`${styles.widgetBody}`} id="settingOpt">
          <div className={`${styles.wrpRow} `}>
          <div className={`${styles.row_Content} row_Content`}><p>{i18next.t('defaultAcc')}</p></div>
          <div className={`${styles.row_Content}`} id="settingAccount">
              <DropdownButton title={account_Name} className={`${styles.settingDefAcc} settingDropdown btnText`} >
                  {this.state.accountList.map((item) => {
                    return (
                      <MenuItem eventKey={item.C} onClick={() => this.changeDefaultAcc(item.C,item.D)} id="selectAccName">{item.D}</MenuItem>
                    );
                  })
                }
              </DropdownButton>
          </div>
          </div>
          <div className={`${styles.wrpRow}`}>
              <div className={`${styles.row_Content} row_Content`}>
                <p>{i18next.t('fontSize')}</p>
              </div>
               <div className={`${styles.row_Content} row_Content`}>
                  <div className={`${styles.fontContent} fontContent`}>
                    <label className={`cust-circle `+(this.props.userDetail.selectedTheme)+`_cust-circle`} htmlFor="selectFontSmall">
                      <input type="radio" checked={this.state.fontsize === "S"} value="S" name="group1" onClick={this.selectfont} id="selectFontSmall" />
                      <span className={`checkR `+(this.props.userDetail.selectedTheme)+`_checkR`}></span>
                    </label>
                  <span> A<sup>-</sup></span>
               </div>
                  <div className={`${styles.fontContent} fontContent`}>
                    <label className={`cust-circle `+(this.props.userDetail.selectedTheme)+`_cust-circle`} htmlFor="selectFontNormal">
                      <input type="radio" checked={this.state.fontsize === "N"} value="N" name="group1" onClick={this.selectfont} id="selectFontNormal"/>
                      <span className={`checkR `+(this.props.userDetail.selectedTheme)+`_checkR`}></span>
                    </label>
                    <span> A<sup></sup></span>
                  </div>
                  <div className={`${styles.fontContent} fontContent`}>
                    <label className={`cust-circle `+(this.props.userDetail.selectedTheme)+`_cust-circle`} htmlFor="selectFontBig">
                      <input type="radio" checked={this.state.fontsize === "B"} value="B" name="group1" onClick={this.selectfont} id="selectFontBig"/>
                      <span className={`checkR `+(this.props.userDetail.selectedTheme)+`_checkR`}></span>
                    </label>
                    <span> A<sup>+</sup></span></div>
                  </div>
          </div>
          <div className={`${styles.wrpRow}`}>
              <div className={`${styles.row_Content} row_Content`}>
                  <p>{i18next.t('trdExecution')}</p>
              </div>
              <div className={`${styles.row_Content}`}>
                <div className={`${styles.trdcontent} trdcontent`}>
                  <label className={`cust-circle `+(this.props.userDetail.selectedTheme)+`_cust-circle`} htmlFor="trdExecRadio1">
                    <input type="radio"  checked={this.state.enableIntTrad==='1'} value={'1'} name="group2" onChange ={this.enableTradeChange} id="trdExecRadio1"/>
                    <span className={`checkR `+(this.props.userDetail.selectedTheme)+`_checkR`}></span>
                  </label>
                  <span> 1-{i18next.t('click')}</span>
                </div>
                <div className={`${styles.trdcontent} trdcontent`}>
                  <label className={`cust-circle `+(this.props.userDetail.selectedTheme)+`_cust-circle`}  htmlFor="trdExecRadio2">
                    <input type="radio" checked={this.state.enableIntTrad==='0'} value={'0'} name="group2" onChange={this.enableTradeChange} id="trdExecRadio2"/>
                    <span className={`checkR `+(this.props.userDetail.selectedTheme)+`_checkR`}></span>
                  </label>
                  <span> 2-{i18next.t('click')}</span>
                </div>
              </div>
            </div>
            <div className={`${styles.wrpRow}`}>
              <div className={`${styles.row_Content} row_Content`}>
                  <p>{i18next.t('pricePerTooltip')}</p>
              </div>
              <div className={`${styles.row_Content}`}>
                  <div className={`${styles.trdcontent} trdcontent`}>
                    <label className={`cust-circle `+(this.props.userDetail.selectedTheme)+`_cust-circle`} htmlFor="tooltipEnable">
                      <input type="radio" checked={this.state.enableToolTip === '1'} value={'1'} name="group3" onChange ={this.tooltipChange} id="tooltipEnable"/>
                      <span className={`checkR `+(this.props.userDetail.selectedTheme)+`_checkR`}></span>
                    </label>
                    <span> {i18next.t('enable')}</span>
                  </div>
                  <div className={`${styles.trdcontent} trdcontent`}>
                  <label className={`cust-circle `+(this.props.userDetail.selectedTheme)+`_cust-circle`} htmlFor="tooltipDisable">
                      <input type="radio" checked={this.state.enableToolTip === '0'} value={'0'} name="group3" onChange={this.tooltipChange} id="tooltipDisable"/>
                      <span className={`checkR `+(this.props.userDetail.selectedTheme)+`_checkR`}></span>
                    </label>
                    <span> {i18next.t('disable')}</span>
                  </div>
              </div>
           </div>
           <div className={`${styles.wrpRow}`}>
             <div className={`${styles.row_Content} row_Content`}>
                 <p>{i18next.t('maintainLastTrdQty')}</p>
             </div>
             <div className={`${styles.row_Content}`}>
              <div className={`${styles.trdcontent} trdcontent`}>
                <label className={`cust-circle `+(this.props.userDetail.selectedTheme)+`_cust-circle`} htmlFor="lastTrdQtyEnable">
                  <input type="radio" checked={this.state.lastTrdQty === '1'} value={'1'} name="group4" onChange ={this.lastTrdQtyChange} id="lastTrdQtyEnable"/>
                  <span className={`checkR `+(this.props.userDetail.selectedTheme)+`_checkR`}></span>
                </label>
                <span> {i18next.t('enable')}</span>
              </div>
              <div className={`${styles.trdcontent} trdcontent`}>
                <label className={`cust-circle `+(this.props.userDetail.selectedTheme)+`_cust-circle`} htmlFor="lastTrdQtyDisable">
                  <input type="radio" checked={this.state.lastTrdQty === '0'} value={'0'} name="group4" onChange={this.lastTrdQtyChange} id="lastTrdQtyDisable"/>
                  <span className={`checkR `+(this.props.userDetail.selectedTheme)+`_checkR`}></span>
                </label>
               <span> {i18next.t('disable')}</span>
              </div>
             </div>
          </div>
          {this.props.userDetail.enableCustomerOrder && !this.props.userDetail.SUB_TRD?
            this.props.userDetail.newRiskCheckType==="MT_Perc" || this.props.userDetail.newRiskCheckType==="MT_AsPerAcc" && this.props.DFA.MT==="MT_Perc"  ?
            <div className={`${styles.wrpRow}`}>
              <div className={`${styles.row_Content} row_Content`}>
                  <p>{i18next.t('isMarginWithOrders')}</p>
              </div>
              <div className={`${styles.row_Content}`}>
               <div className={`${styles.trdcontentWithOrd} trdcontent`}>
                  <label className={`cust-circle `+(this.props.userDetail.selectedTheme)+`_cust-circle`} htmlFor="withOrd">
                      <input type="radio" checked={this.state.isMarginWithOrders === '1'} value={'1'} name="group5" onChange ={this.withOrdChange} id="withOrd"/>
                      <span className={`checkR `+(this.props.userDetail.selectedTheme)+`_checkR`}></span>
                  </label>
                  <span> {i18next.t('withOrd')}</span>
                </div>
               <div className={`${styles.trdcontent} trdcontent`}>
                  <label className={`cust-circle `+(this.props.userDetail.selectedTheme)+`_cust-circle`} htmlFor="withoutOrd">
                    <input type="radio" checked={this.state.isMarginWithOrders === '0'} value={'0'} name="group5" onChange={this.withOrdChange} id="withoutOrd"/>
                    <span className={`checkR `+(this.props.userDetail.selectedTheme)+`_checkR`}></span>
                  </label>
                  <span> {i18next.t('withoutOrd')}</span>
               </div>
              </div>
            </div>:null
          :null}

          <div className={`${styles.wrpRow}`}>
            <div className={`${styles.row_Content} row_Content`}>
                <p>{i18next.t('language')}</p>
            </div>
            <div className={`${styles.row_Content}`} id="stLang">
                <DropdownButton title={i18next.t(this.state.selectedLng)}  className="btnText">
                  { this.props.langList.map((item) => {
                      return (
                        <MenuItem eventKey={item.lang_code} onClick={() => this.selectLang(item.lang_code,item.lang_desc)} id="selectLanguage">{i18next.t(item.lang_desc)}</MenuItem>
                      );
                    })
                  }
              </DropdownButton>
            </div>
          </div>

          {this.props.userDetail.themeType !== 1 ?
            <div className={`${styles.wrpRow}`}>
              <div className={`${styles.row_Content} row_Content`}>
                  <p>{i18next.t('theme')}</p>
              </div>
              <div className={`${styles.row_Content}`} id="stTheme">
                <DropdownButton title={i18next.t(this.state.selectedCssColorId)} className="settingDropdown btnText">
                  {
                    this.props.allCssColor.map((menuItems) =>
                    <MenuItem
                      onClick={() => this.changeThemeHanlder(menuItems)} >
                      {i18next.t(menuItems.theme_code)}
                    </MenuItem> )
                  }
                </DropdownButton>
              </div>
            </div>
          :null}

        <div className={`${styles.button_Content} col-sm-7 col-sm-offset-5 button_Content`}>
             <ButtonToolbar>
               <Button className={`${styles.savebutton} profileButton savebutton`} onClick={this.saveSetting} id="saveChangSetting">{i18next.t('save')}</Button>
             </ButtonToolbar>
        </div>
      </div>
    );
  }
}
